import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { IS_USER_LOGGED_IN } from "helpers/constants";

import { getUserSettingsByUserID } from "actions/userSettings";
import { updateAllAccountsInNotificationDevice } from "actions/notifications";

import FirebaseNotifications from "notifications/FirebaseNotifications";

import useTheme from "hooks/useTheme";

import Dashboard from "views/Dashboard";
import SwapAssets from "views/SwapAssets";
import AssetInfo from "views/components/assets/AssetInfo";
import ImportTAccount from "views/ImportTAccount";
import CreateTAccount from "views/CreateTAccount";
import Auth from "views/Auth";
import Settings from "views/Settings";
import Accounts from "views/Accounts";
import Contacts from "views/Contacts";
import Profile from "views/Profile";
import Register from "views/components/auth/Register";
import Login from "views/components/auth/Login";
import { getDeviceInfo } from "actions/auth";
import SendAsset from "views/SendAsset";
import Header from "views/components/partials/Header";
import Sidebar from "views/components/partials/Sidebar";
import DaffiBuy from "views/DaffiBuy";
import useNotification from "hooks/useNotification";
import { getAppPreferences } from "actions/appPreferences";
import DaffiPay from "views/DaffiPay";
import WalletConnect from "views/WalletConnect";
import ComingSoon from "views/ComingSoon";
import NFTInfo from "views/components/dashboard/nfts/NFTInfo";

function App() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { themeColor } = useTheme();
	const { notify } = useNotification();

	const isUserLoggedIn = useSelector((state) => state.Auth.isUserLoggedIn);
	const buildingApp = useSelector((state) => state.BuildingApp);

	const navigatePage = (to) => {
		navigate(to);
	};

	useEffect(() => {
		navigatePage("/");

		dispatch(getDeviceInfo());
		dispatch({ type: IS_USER_LOGGED_IN });

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isUserLoggedIn) {
			dispatch(getAppPreferences());
			dispatch(getUserSettingsByUserID());
			dispatch(updateAllAccountsInNotificationDevice(notify));
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isUserLoggedIn]);

	// change color of scrollbar as themeColor
	useEffect(() => {
		const style = document.createElement("style");

		style.innerHTML = `
		::-webkit-scrollbar-track {
        background: ${themeColor?.hex + 40};
        border-radius: 5px;
    }
		::-webkit-scrollbar-thumb {
				background-color: ${themeColor?.hex};
			}
			body {
				scrollbar-color: ${themeColor?.hex};
			}`;

		document.head.appendChild(style);
	}, [themeColor]);

	// console.log(useSelector((state) => state));

	return (
		<>
			<FirebaseNotifications />
			<ToastContainer />
			<div className="App flex flex-col h-screen">
				{isUserLoggedIn ? (
					buildingApp ? (
						<div className="flex flex-col w-full h-full items-center justify-center space-y-5">
							<p className={`text-3xl font-bold ${themeColor?.text}`}>
								Daffi<span className="italic">Wallet</span>
							</p>
							<img className="animate-spin mx-auto h-6 w-auto" src="/media/logo.png" alt="img" />
						</div>
					) : (
						<>
							<Header navigatePage={navigatePage} />
							<div className="flex flex-1 overflow-hidden space-x-5 2xl:px-56 xl:px-32">
								<Sidebar navigatePage={navigatePage} />
								<main className="flex flex-1 overflow-y-auto">
									<Routes>
										<Route path="/" element={<Dashboard />} />
										<Route path="/Accounts" element={<Accounts />} />
										<Route path="/Contacts" element={<Contacts />} />
										<Route path="/Profile" element={<Profile navigatePage={navigatePage} />} />
										<Route path="/ImportTAccount" element={<ImportTAccount navigatePage={navigatePage} />} />
										<Route path="/CreateTAccount" element={<CreateTAccount navigatePage={navigatePage} />} />
										<Route path="/Send" element={<SendAsset navigatePage={navigatePage} />} />
										<Route path="/Swap" element={<SwapAssets navigatePage={navigatePage} />} />
										<Route path="/Buy" element={<DaffiBuy navigatePage={navigatePage} />} />
										<Route path="/Pay" element={<DaffiPay navigatePage={navigatePage} />} />
										<Route path="/WalletConnect" element={<WalletConnect navigatePage={navigatePage} />} />
										<Route path="/NFTInfo" exact element={<NFTInfo navigatePage={navigatePage} />} />
										<Route path="/AssetInfo" exact element={<AssetInfo navigatePage={navigatePage} />} />
										<Route path="/Settings" exact element={<Settings />} />
										<Route path="/Connect" exact element={<ComingSoon />} />
										<Route path="/Search" exact element={<ComingSoon />} />
										<Route path="/Reports" exact element={<ComingSoon />} />
									</Routes>
								</main>
							</div>
						</>
					)
				) : (
					<Routes>
						<Route path="/" element={<Auth navigatePage={navigatePage} />} />
						<Route path="/Login" element={<Login navigatePage={navigatePage} />} />
						<Route path="/Register" element={<Register navigatePage={navigatePage} />} />
					</Routes>
				)}
			</div>
		</>
	);
}

export default App;
